import { can, clientName, formatDate } from '@clim/client-core';
import { SAV_OPEN, type SavStatus } from '@clim/domain';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SavBadge } from '../components/DossierSav';
import { Empty } from '../components/ui';
import { useEngine, useReady } from '../lib/session';
import { useTerritory } from '../lib/territory';

type Filter = 'open' | SavStatus | 'all';

/** SAV (§12) : à valider, à planifier, en cours, à clôturer ; lien vers le dossier. */
export function SavListPage() {
  const engine = useEngine();
  const { me } = useReady();
  const { territoryId } = useTerritory();
  const [filter, setFilter] = useState<Filter>(can(me, 'sav.validate') ? 'pending_validation' : 'open');
  const all = engine
    .list('sav')
    .filter((s) => !territoryId || s.territoryId === territoryId)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  const shown = all.filter((s) => (filter === 'all' ? true : filter === 'open' ? SAV_OPEN.includes(s.status) : s.status === filter));
  const count = (f: Filter) => all.filter((s) => (f === 'all' ? true : f === 'open' ? SAV_OPEN.includes(s.status) : s.status === f)).length;
  const tabs: [Filter, string][] = [
    ['open', 'Tous ouverts'],
    ['pending_validation', 'À valider'],
    ['done', 'À clôturer'],
    ['closed', 'Clôturés'],
    ['all', 'Tous'],
  ];
  return (
    <div>
      <h1>SAV</h1>
      <div className="chips" role="tablist">
        {tabs.map(([f, l]) => (
          <button key={f} type="button" role="tab" aria-selected={filter === f} className={`chip${filter === f ? ' on' : ''}`} onClick={() => setFilter(f)}>
            {l} ({count(f)})
          </button>
        ))}
      </div>
      {!shown.length ? (
        <Empty>Aucun SAV.</Empty>
      ) : (
        <ul className="list">
          {shown.map((s) => {
            const d = engine.get('dossier', s.dossierId);
            const c = d ? engine.get('client', d.clientId) : undefined;
            const reason = engine.get('reason', s.reasonId)?.label ?? '—';
            return (
              <li key={s.id}>
                <Link to={`/dossiers/${s.dossierId}`} className="row">
                  <span className="row-main">
                    <strong>
                      {c ? clientName(c) : 'Client'} · {reason}
                    </strong>
                    <span className="muted">
                      {s.reference ?? d?.reference ?? '—'} · {formatDate(s.createdAt)} · {s.createdByName}
                      {s.installerName ? ` · posé par ${s.installerName}` : ''}
                    </span>
                  </span>
                  <SavBadge s={s} />
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
